import { QueryClient } from '@tanstack/react-query'
import { registerIdentityCleanup } from '@/api/request-context'
export const queryClient = new QueryClient({ defaultOptions: { queries: { retry: false, staleTime: 10_000, refetchOnWindowFocus: false }, mutations: { retry: false } } })
registerIdentityCleanup(() => {
  void queryClient.cancelQueries()
  queryClient.clear()
})
